import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { useSite } from "@/context/SiteContext";
import { PageHero, Prose } from "@/components/common";
import { saveConsent } from "@/components/layout/CookieBanner";
import { hasStatsConsent } from "@/lib/api";
import NotFound from "@/pages/NotFound";
import useTitle from "@/lib/useTitle";

function ConsentToggle() {
  const [on, setOn] = useState(hasStatsConsent());
  return (
    <div className="mt-8 flex items-center justify-between gap-4 rounded-2xl border bg-white p-5">
      <label htmlFor="stats-consent" className="font-semibold">Permitir estatísticas anónimas de visitas</label>
      <Switch id="stats-consent" checked={on} onCheckedChange={(v) => { setOn(v); saveConsent(v); toast.success("Preferência guardada"); }} data-testid="cookies-stats-switch" />
    </div>
  );
}

export default function PageView({ slug, withConsent }) {
  const { data } = useSite();
  const p = data.pages.find((x) => x.slug === slug);
  useTitle(p?.title);
  if (!p) return <NotFound />;
  return (
    <>
      <PageHero eyebrow={slug === "memoria" ? "Galeria e memória" : "Informação legal"} title={p.title} tone={slug === "memoria" ? "#be185d" : "#1e293b"} image={slug === "memoria" ? "/img/gathering.jpg" : undefined} />
      <div className="container-x py-12 max-w-3xl" data-testid={`page-${slug}`}>
        <Prose text={p.body} className="text-base md:text-lg" />
        {withConsent && <ConsentToggle />}
      </div>
    </>
  );
}
